export default "__VITE_ASSET__BzAxP3aq__"